import { marketPlaceBaseQueryWrapper } from "@/utils/rtkHelper";
import { createApi } from "@reduxjs/toolkit/query/react";
import {
  ActualReturnSearch,
  ActualReturnSearchResult,
  ActualReturnSummaryResult,
  TrackingIdResponse,
  GetMissingTrackingData
} from "@/types/meesho/meeshoActualReturn";


export const MeeshoActualReturnApi = createApi({
  reducerPath: "MeeshoActualReturnApi",
  baseQuery: marketPlaceBaseQueryWrapper,
  keepUnusedDataFor: 0,
  tagTypes: ["meeshosalesReturn"],
  endpoints: (builder) => ({
    uploadActualReturn: builder.mutation({
      query: ({ formData }) => ({
        url: `/meesho-actual-return-status/actualreturn/xlsx`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["meeshosalesReturn"],
    }),
    searchActualReturn: builder.query<
      ActualReturnSearchResult,
      ActualReturnSearch
    >({
      query: (input) => ({
        url: `/meesho-actual-return-status/actualsearch`,
        method: "POST",
        body: { ...input, export: false },
      }),
      providesTags: ["meeshosalesReturn"],
    }),
    exportActualReturn: builder.mutation<Blob, ActualReturnSearch>({
      query: (input) => ({
        url: `/meesho-actual-return-status/actualsearch`,
        method: "POST",
        body: { ...input, export: true },
        responseHandler: (response: Response) => response.blob(),
      }),
    }),
    summaryActualReturn: builder.query<
      ActualReturnSummaryResult,
      ActualReturnSearch
    >({
      query: (input) => ({
        url: `/meesho-actual-return-status/actualsummary`,
        method: "POST",
        body: input,
      }),
      providesTags: ["meeshosalesReturn"],
    }),
    deleteActualReturns: builder.mutation<void, string[]>({
      query: (ids) => ({
        url: "/meesho-actual-return-status/delete",
        method: "DELETE",
        body: { ids },
      }),
      invalidatesTags: ["meeshosalesReturn"],
    }),
    getTrackingIdData: builder.query<TrackingIdResponse, void>({
      query: () => ({
        url: `/meesho-actual-return-status/tracking-id`,
        method: "GET",
      }),
    }),
   
    addManualReturnStatus: builder.mutation<void, any>({
      query: (input) => ({
        url: `/meesho-actual-return-status/create_actual_return`,
        method: "POST",
        body: input,
      }),
      invalidatesTags: ["meeshosalesReturn"],
    }),
    getMissingData: builder.query<GetMissingTrackingData, void>({
      query: () => ({
        url: `/meesho-actual-return-status/missing`,
        method: "GET",
      }),
    }),

  }),
});

export const {
  useUploadActualReturnMutation,
  useSearchActualReturnQuery,
  useLazySearchActualReturnQuery,
  useExportActualReturnMutation,
  useSummaryActualReturnQuery,
  useDeleteActualReturnsMutation,
  useLazyGetTrackingIdDataQuery,
  useAddManualReturnStatusMutation,
  useLazyGetMissingDataQuery,
} = MeeshoActualReturnApi;
